import { gql } from '@apollo/client';

const GET_DEFAULT_GROUP_SETTINGS = gql`
  query getDefaultGroupSettings {
    defaultGroupSettings {
      gradeLevels
      productCodes
      group {
        appId
        name
        groupCategory {
          appId
          name
        }
      }
    }
  }
`;

export default GET_DEFAULT_GROUP_SETTINGS;
